<agr-form-dialog [formGroup]="formGroup" [data]="data" (cancel)="cancel()">
  @for (table of tableReportData$ | async; track table) {
    <div class="avoid-page-break">
      <mat-table class="table-wrapper" [dataSource]="table.organicMatterItems" data-test="organic-matter-table">
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef class="flex__child flex__child-4 flex text--bold">
            <div class="text--right spacing--margin-right">
              <span class="text--bold">
                <ng-container
                  >{{ table.translateName ? (table.name | translate) : table.name }} ({{
                    table.totalHectares | number: '1.0-0'
                  }}
                  ha)</ng-container
                >
              </span>
            </div>
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex__child flex__child-4">
            <span>{{ element.source | translate }} </span>
          </mat-cell>
          <mat-footer-cell *matFooterCellDef class="flex__child-4">
            <ng-container
              ><span class="text--bold">{{ 'balance' | translate }}</span></ng-container
            >
          </mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="total">
          <mat-header-cell *matHeaderCellDef>
            <div class="text--right is-wide text--no-wrap text--bold">
              {{ 'killogramsOrganicMatterValue' | translate }}
            </div>
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex__child">
            <div class="text--right is-wide">
              {{ element.data.total | number: '1.0-0' }}
            </div>
          </mat-cell>
          <mat-footer-cell *matFooterCellDef>
            <div class="text--right is-wide text--bold" [class.text--error]="table.balance < 0">
              {{ table.balance | number: '1.0-0' }}
            </div>
          </mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="perHectare">
          <mat-header-cell *matHeaderCellDef>
            <div class="text--right is-wide text--no-wrap text--bold">
              {{ 'organicMatterValue' | translate }}
            </div>
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex__child">
            <div class="text--right is-wide">
              {{ element.data.perHectare | number: '1.0-0' }}
            </div>
          </mat-cell>
          <mat-footer-cell *matFooterCellDef>
            <div class="text--right is-wide text--bold" [class.text--error]="table.balancePerHectare < 0">
              {{ table.balancePerHectare | number: '1.0-0' }}
            </div>
          </mat-footer-cell>
        </ng-container>
        <mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
          data-test="fertilization-table__header"
          class="has-hover-hightlighting"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns" class="has-hover-hightlighting"></mat-row>
        <mat-footer-row *matFooterRowDef="displayedColumns" class="has-hover-hightlighting"></mat-footer-row>
      </mat-table>
      <br /><br />
    </div>
  }
</agr-form-dialog>
